import rightArrowIcon from "@assets/icons/settingsCards/right_arrow.svg";
import { useNavigate } from "react-router-dom";

export default function SettingsCard({ data }) {
  const navigate = useNavigate();
  return (
    <div
      className="flex justify-between px-5 py-4 border cursor-pointer border-border rounded-xl hover:bg-gray-50"
      onClick={() => navigate(data.path)}
    >
      <div className="flex gap-2.5 items-center">
        <img src={data.icon} alt={data.label} />
        <label className="text-sm font-medium">{data.label}</label>
      </div>
      <div>
        <img src={rightArrowIcon} alt={"right arrow"} />
      </div>
    </div>
  );
}
